const reducers = (state, action) => {
  switch (action.type) {
    case "SET_FLASH_MESSAGE":
      return {
        ...state,
        flash_message: action.payload,
      };
    case "SET_RETIREMENT_CALC":
      return {
        ...state,
        retirement_calc: action.payload
      }
    // case "ADD_TODO":
    //   return {
    //     ...state,
    //     todos: [...state.todos, action.payload],
    //   };
    // case "SET_TODO_INPUT":
    //   return {
    //     ...state,
    //     todoInput: action.payload,
    //   };
    default:
      return state;
  }
};

export default reducers;
